module.exports = __webpack_public_path__ + "img/symbols.94d3aea7.svg";